import 'css-chunksrc/client/scenes/list/details/styles.scss';export default {
  "details": "_details_mxjm7_1",
  "name": "_name_mxjm7_5",
  "input": "_input_mxjm7_15",
  "description": "_description_mxjm7_25",
  "label": "_label_mxjm7_29",
  "paragraph": "_paragraph_mxjm7_35",
  "advancement": "_advancement_mxjm7_45",
  "percentage": "_percentage_mxjm7_52",
  "progressBar": "_progressBar_mxjm7_61",
  "advancementLabel": "_advancementLabel_mxjm7_66",
  "descriptionMaxChars": "_descriptionMaxChars_mxjm7_73",
  "loader": "_loader_mxjm7_78",
  "loaderMain": "_loaderMain_mxjm7_86"
};